var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "location-page-container" }, [
    _c("div", { staticClass: "search-container" }, [
      _c("div", { staticClass: "form" }, [
        _c("div", { staticClass: "form-fields-stack w-mob regions" }, [
          _c("div", { staticClass: "form-field text search" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.payload.keyword,
                  expression: "payload.keyword"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text", placeholder: "Search by keyword" },
              domProps: { value: _vm.payload.keyword },
              on: {
                keyup: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.loadLocations(true)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.payload, "keyword", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "geolocate",
              attrs: { src: "/images/icons/geo-location-gray.svg", alt: "" },
              on: {
                click: function($event) {
                  return _vm.$refs.mymap.geolocate()
                }
              }
            })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filters" }, [
          _c("div", { staticClass: "filter-links" }, [
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    return _vm.toggleShow("regions")
                  }
                }
              },
              [
                _vm._v("\n            Regions\n            "),
                _c("img", {
                  class: { up: _vm.showRegionFilter },
                  attrs: { src: "/images/icons/icon_arrow_down.svg" }
                })
              ]
            ),
            _vm._v(" "),
            _vm.showRegionFilter
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "on-clickaway",
                        rawName: "v-on-clickaway",
                        value: function() {
                          return (_vm.showRegionFilter = false)
                        },
                        expression: "() => showRegionFilter = false"
                      }
                    ],
                    staticClass: "filter-dropdown"
                  },
                  [
                    _c(
                      "ul",
                      _vm._l(_vm.mapRegions, function(region, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            staticClass:
                              "filter-dropdown-item form-field checkbox"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "custom-checkbox-radio" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "title",
                                    on: {
                                      click: function($event) {
                                        return _vm.check(
                                          null,
                                          "regions",
                                          region
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(region.title))]
                                )
                              ]
                            )
                          ]
                        )
                      }),
                      0
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "a",
              {
                on: {
                  click: function($event) {
                    return _vm.toggleShow("locations")
                  }
                }
              },
              [
                _vm._v("\n            Service Types\n            "),
                _c("img", {
                  class: { up: _vm.showLocationTypeFilter },
                  attrs: { src: "/images/icons/icon_arrow_down.svg" }
                })
              ]
            ),
            _vm._v(" "),
            _vm.showLocationTypeFilter
              ? _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "on-clickaway",
                        rawName: "v-on-clickaway",
                        value: function() {
                          return (_vm.showLocationTypeFilter = false)
                        },
                        expression: "() => showLocationTypeFilter = false"
                      }
                    ],
                    staticClass: "filter-dropdown"
                  },
                  [
                    _c(
                      "ul",
                      [
                        _vm._l(_vm.mapTypes, function(type, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass:
                                "filter-dropdown-item form-field checkbox"
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "custom-checkbox-radio" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.selected_types,
                                        expression: "selected_types"
                                      }
                                    ],
                                    attrs: { type: "checkbox", id: type.title },
                                    domProps: {
                                      value: type.title,
                                      checked: Array.isArray(_vm.selected_types)
                                        ? _vm._i(
                                            _vm.selected_types,
                                            type.title
                                          ) > -1
                                        : _vm.selected_types
                                    },
                                    on: {
                                      change: function($event) {
                                        var $$a = _vm.selected_types,
                                          $$el = $event.target,
                                          $$c = $$el.checked ? true : false
                                        if (Array.isArray($$a)) {
                                          var $$v = type.title,
                                            $$i = _vm._i($$a, $$v)
                                          if ($$el.checked) {
                                            $$i < 0 &&
                                              (_vm.selected_types = $$a.concat([
                                                $$v
                                              ]))
                                          } else {
                                            $$i > -1 &&
                                              (_vm.selected_types = $$a
                                                .slice(0, $$i)
                                                .concat($$a.slice($$i + 1)))
                                          }
                                        } else {
                                          _vm.selected_types = $$c
                                        }
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass: "title",
                                      attrs: { for: type.title }
                                    },
                                    [_vm._v(_vm._s(type.title))]
                                  )
                                ]
                              )
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "li",
                          {
                            staticClass: "flex clear",
                            on: {
                              click: function($event) {
                                _vm.selected_types = []
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: "/images/icons/clear-lblue.svg",
                                alt: ""
                              }
                            }),
                            _vm._v(
                              "\n                Clear all\n              "
                            )
                          ]
                        )
                      ],
                      2
                    )
                  ]
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-list" }, [
            _vm.selected_region.length > 0
              ? _c(
                  "button",
                  {
                    staticClass: "filtered-button",
                    on: {
                      click: function($event) {
                        _vm.selected_region = []
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: "/images/icons/clear-lblue.svg" }
                    }),
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.selected_region[0]) +
                        "\n          "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.selected_types.length > 0
              ? _c(
                  "span",
                  _vm._l(_vm.selected_types, function(type, index) {
                    return _c(
                      "button",
                      {
                        key: index,
                        staticClass: "filtered-button",
                        on: {
                          click: function($event) {
                            return _vm.selected_types.splice(index, 1)
                          }
                        }
                      },
                      [
                        _c("img", {
                          attrs: { src: "/images/icons/clear-lblue.svg" }
                        }),
                        _vm._v(
                          "\n              " + _vm._s(type) + "\n            "
                        )
                      ]
                    )
                  }),
                  0
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "filter-button",
              on: {
                click: function($event) {
                  return _vm.loadLocations(true)
                }
              }
            },
            [_vm._v("Search")]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "locations-container flex" },
      [
        _c(
          "div",
          {
            staticClass: "locations-list",
            class: { active: _vm.view === "list" }
          },
          [
            _c(
              "div",
              { staticClass: "results" },
              _vm._l(_vm.places, function(article) {
                return _c("article", { key: article.id }, [
                  _c(
                    "a",
                    { staticClass: "title", attrs: { href: article.url } },
                    [_c("h3", [_vm._v(_vm._s(article.title))])]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _c("div", { staticClass: "location flex" }, [
                      _c("img", {
                        attrs: { src: "/images/location.svg", alt: "" }
                      }),
                      _vm._v(" "),
                      _c("span", {
                        domProps: { innerHTML: _vm._s(article.address) }
                      })
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "phone flex",
                        attrs: { href: "tel:" + article.phone }
                      },
                      [
                        _c("img", {
                          attrs: { src: "/images/phone.svg", alt: "" }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(article.phone))])
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "map",
                        on: {
                          click: function($event) {
                            return _vm.showInMap(article)
                          }
                        }
                      },
                      [_vm._v("View on Map")]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "services",
                        on: {
                          click: function($event) {
                            return _vm.toggleServices(article)
                          }
                        }
                      },
                      [
                        article.show
                          ? _c("span", [
                              _c("span", { staticClass: "circle" }, [
                                _vm._v("+")
                              ]),
                              _vm._v(" Show Services")
                            ])
                          : _c("span", [
                              _c("span", { staticClass: "circle close" }, [
                                _vm._v("-")
                              ]),
                              _vm._v(" Hide Services")
                            ])
                      ]
                    ),
                    _vm._v(" "),
                    !article.show
                      ? _c(
                          "ul",
                          { staticClass: "list" },
                          _vm._l(article.features, function(feature, indx) {
                            return _c(
                              "li",
                              { key: indx, staticClass: "button grey-border" },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(feature) +
                                    "\n              "
                                )
                              ]
                            )
                          }),
                          0
                        )
                      : _vm._e()
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "detail-buttons" }, [
                    _c(
                      "a",
                      {
                        staticClass: "map details",
                        class: { full: !article.book_now },
                        attrs: { href: article.url }
                      },
                      [_vm._v("\n              View Details\n            ")]
                    ),
                    _vm._v(" "),
                    article.book_now
                      ? _c("a", { attrs: { href: article.book_now } }, [
                          _vm._v("\n               Book Now\n            ")
                        ])
                      : _vm._e()
                  ])
                ])
              }),
              0
            )
          ]
        ),
        _vm._v(" "),
        _c("app-map", {
          ref: "mymap",
          class: { active: _vm.view === "map" },
          attrs: {
            latitude: _vm.center.latitude,
            longitude: _vm.center.longitude,
            zoomed: _vm.init_zoom,
            initmarkers: _vm.locations
          },
          on: { draggedLatLong: _vm.newCoords }
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons-toggle", class: { unfix: !_vm.fixed } },
          [
            _c(
              "button",
              {
                class: { active: _vm.view === "map" },
                on: {
                  click: function($event) {
                    return _vm.switchView("map")
                  }
                }
              },
              [_vm._v("View Map")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                class: { active: _vm.view === "list" },
                on: {
                  click: function($event) {
                    return _vm.switchView("list")
                  }
                }
              },
              [_vm._v("List View")]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cfc7e11", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfc7e11","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/locations/IndexWithMap.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2cfc7e11","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/frontend/js/components/locations/IndexWithMap.vue
// module chunks = 0